import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './TooltipItem.scss';

const TooltipItem = ({ item, customClass = '' }) => {
  const name = useRef();
  const [hasNameEllipsis, setHasNameEllipsis] = useState(false);

  useEffect(() => {
    let popover;
    if (name.current.scrollWidth > name.current.offsetWidth) {
      setHasNameEllipsis(true);
      popover = new bootstrap.Popover(name.current, {
        boundary: 'window',
        container: 'body',
        content: item,
        placement: 'top',
        trigger: 'hover',
      });
      popover.enable();
    } else {
      setHasNameEllipsis(false);
    }
    return () => {
      popover?.dispose();
    };
  }, [item]);

  return (
    <div
      ref={name}
      className={`text-ellipsis ${customClass} tooltip-item ${
        hasNameEllipsis ? '' : 'noEllipsis'
      }`}>
      {item}
    </div>
  );
};

TooltipItem.propTypes = {
  item: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  customClass: PropTypes.string,
};

export default TooltipItem;
